import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Router } from '@angular/router';
import { ContactField } from '../../models/contact-field';
import { BookingService } from '../../../booking/services/booking.service';
import { BookingStepService } from '../../../booking/services/booking-step.service';
import { BookingStepEnum } from '../../../booking/models/booking-step.enum';
import { CompanyInfoStateService } from '../../services/company-info-state.service';
import { NgForm } from '@angular/forms';
import { LocalizationService } from '../../../../services/localization.service';
import { LoadingSpinnerService } from '../../../../services/loading-spinner.service';
import { NotificationService } from '../../../general/services/notification.service';
import { Company } from '../../models/company';


@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit, OnDestroy {

  name: string;
  email: string;
  message: string;
  agreement: boolean;

  private _formProcessing = false;

  _google_map_settings: any;
  @ViewChild('appTextarea', { static: true }) appTextarea;
  @ViewChild(NgForm, { static: true }) form;


  constructor(
    private router: Router,
    private bookingService: BookingService,
    private bookingStepService: BookingStepService,
    private companyInfoStateService: CompanyInfoStateService,
    private localizationService: LocalizationService,
    private loadingSpinnerService: LoadingSpinnerService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit(): void {
    this.companyInfoStateService.initialize().subscribe();
    this.companyInfoStateService.initializeTodayWorkingHours().subscribe();
    this._google_map_settings = environment.globalSettings.google_map_settings;
  }

  get formProcessing(): boolean {
    return this._formProcessing;
  }

  onSend(): void {
    if (this.isFormValid && !this._formProcessing) {
      this.loadingSpinnerService.show();
      this._formProcessing = true;

      const contactField = new ContactField();
      contactField.name = this.name;
      contactField.email = this.email;
      contactField.message = this.message;
      contactField.lang = this.localizationService.currentLang;
      console.log('send');

      this.bookingService.sendContactForm(contactField).subscribe(
        result => {
          this._formProcessing = false;
          this.bookingStepService.update(BookingStepEnum.GroupEventThankYou);
          this.loadingSpinnerService.hide();
        },
        error => {
          this._formProcessing = false;
          this.notificationService.show(ContactComponent.name, 'Error during sending mail');
          this.loadingSpinnerService.hide();
        });
    }
  }

  onClickFAQ(): void {
    this.router.navigateByUrl('faq');
  }

  get company(): Company {
    return this.companyInfoStateService.companyInfo;
  }

  get companyEmail(): string {
    if (this.company) {
      return this.company.email;
    }
    return '';
  }

  get companyPhone(): string {
    if (this.company) {
      return this.company.phone;
    }
    return '';
  }

  get isFormValid(): boolean {
    return this.form.valid;
  }

  get google_map_settings(): any {
    const companyInfo = this.companyInfoStateService.companyInfo;
    if (!companyInfo) {
      return null;
    }
    const google_map_settings = this._google_map_settings;
    if (!google_map_settings) {
      return null;
    }

    google_map_settings['lat'] = companyInfo.gps_lat;
    google_map_settings['lng'] = companyInfo.gps_lng;

    google_map_settings['marker']['lat'] = companyInfo.gps_lat;
    google_map_settings['marker']['lng'] = companyInfo.gps_lng;

    return google_map_settings;
  }

  ngOnDestroy(): void {
    this.notificationService.hide(ContactComponent.name);
  }
}
